import React from 'react';
import { useTranslation } from 'react-i18next';

const ProjectSolutionCalculationResultHeadline = (props) => {

  const { t } = useTranslation();

    if (props.calculator === undefined) {
      return null
    } else {


    const statusSymbol = () => {
      let icon = "info";
      let color = "success";
      let padding = "0";

      switch (props.resSchottbelegung.status) {
        case 'greater_than_max':
          icon = "block";
          color = "danger";
          padding = "0";
          break;
        case 'between_max_and_krit':
          icon = "warning";
          color = "warning";
          padding = "3";
          break;
        case 'lower_than_krit':
          icon = "check";
          color = "success"
          padding = "0";
          break;
        default:
          icon = "";
      }

      return <span className={"btn btn-round bg-" + color} style={{width: "1.5rem", height: "1.5rem", display: "inline-flex", paddingBottom: padding + "px", marginLeft: "10px"}}>
        <i className="material-icons text-white" style={{fontSize: "1.3rem"}}>{icon}</i>
      </span>
    }

    const errors = () => {
      return !( props.resSchottbelegung.errors === undefined || (Array.isArray(props.resSchottbelegung.errors) && props.resSchottbelegung.errors.length === 0) || props.resSchottbelegung.errors === null)
    }

    const currentCoverage = () => {
      if (errors()) {
        return (
          <span>
            { t('product_solution.calculation_result.calculation_not_possible') }
          </span>
        )
      } else {
        return (
          <span>
            <span>
             { t('product_solution.calculation_result.headline.coverage_text', {summe: props.resSchottbelegung.sum_in_percent, maximum: props.resSchottbelegung.max_area_allocation_in_percent}) }
            </span>
            { statusSymbol() }
          </span>
        )
      }
    }


    if (props.calculator.hole_form === "square") {
      return (
        <span>&nbsp;|&nbsp;
          <span ><i className="material-icons hole-icon-square">aspect_ratio</i></span>
          { t('product_solution.calculation_result.headline.square_params', {width: props.calculator.hole_width , height: props.calculator.hole_height }) } | { currentCoverage() }
        </span>
      )
    }

    if (props.calculator.hole_form === "circle") {
      return (
        <span>&nbsp;|&nbsp;
          <span ><i className="material-icons hole-icon-square">hide_source</i></span>
          { t('product_solution.calculation_result.headline.circle_params', {diameter: props.calculator.hole_diameter }) } | { currentCoverage() }
        </span>
      )
    }

    if (props.calculator.hole_form !== "circle" && props.calculator.hole_form !== "square" ) {
      return (
        <span>

        </span>
      )
    }
  }
}



export default ProjectSolutionCalculationResultHeadline



// WEBPACK FOOTER //
// ./src/components/Modals/ProjectSolutionCalculationResultHeadline.js